export const DEFAULT_TIMEZONE = 'Asia/Jakarta';
